import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { formatEntityActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import { toAssistantSurfaceId } from 'tripPlanner/assistant/surfaceSnapshots/assistantSurfacePlainText'

// Text carries grouping identity; structured fields retain the same ID for domain lookups.
export function buildOfferDrawerOpenedActivityEntry(name: string, offerType: string, offerId: string): TripPlannerSurfaceActivityEntry {
  const normalizedOfferId = toAssistantSurfaceId(offerId)
  return {
    kind: 'offer_drawer_opened',
    label: 'Opened offer details',
    displayText: formatEntityActivityDisplayText(`Opened ${offerType} "${name}"`, normalizedOfferId),
    sourcePath: 'trip_planner.drawer.offer',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
    ...(normalizedOfferId !== undefined ? { fields: [{ key: 'offerId', value: normalizedOfferId, dataClassification: 'commercial_surface' }] } : {}),
  }
}
